import React, { useState } from "react";
import { CognitoUser } from "amazon-cognito-identity-js";
import { Link, useNavigate } from "react-router-dom";
import GifLogo from "../../../images/main-logo.gif";
import DurianLogo from "../../../images/durian-logo.png";
import Pencil from "../../../images/pencil.png";
import UserPool from "../../../UserPool";
import Loader from '../../../components/Loader';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!email) {
      setError("Please enter your username or email address");
      return;
    }

    // Trim whitespace
    const username = email.trim();

    if (!username) {
      setError("Please enter your username or email address");
      return;
    }

    setLoading(true);

    const user = new CognitoUser({
      Username: username,
      Pool: UserPool
    });

    user.forgotPassword({
      onSuccess: (data) => {
        setLoading(false);
        setSuccess("Verification code sent to your email!");
        // Navigate to reset password page with email
        setTimeout(() => {
          navigate("/reset-password", { state: { email } });
        }, 2000);
      },
      onFailure: (err) => {
        setLoading(false);
        console.error("Forgot password error:", err);

        if (err.code === "UserNotFoundException") {
          setError("No account found with this username/email");
        } else if (err.code === "LimitExceededException") {
          setError("Too many attempts. Please try again later");
        } else if (err.code === "InvalidParameterException") {
          setError("Invalid username/email format");
        } else {
          setError(err.message || "Failed to send verification code");
        }
      }
    });
  };

  return (
    <div className="flex flex-col md:flex-row justify-center md:justify-between w-full h-auto min-h-screen bg-gradient-to-b from-primary-500 to-secondary-500 py-6 px-4 md:py-10 md:px-16">
      {isLoading && <Loader />}

      <div className="hidden md:flex flex-col gap-5 h-full">
        <div className="flex items-center gap-3">
          <img src={DurianLogo} alt="Durian Technologies" className="h-[50px]" style={{ filter: 'brightness(0) invert(1)' }} />
        </div>
        <div className="flex justify-center w-[485px]">
          <img src={GifLogo} alt="main-logo" className="w-[350px]" />
        </div>
        <div className="w-[485px]">
          <h1 className="text-center text-text-light">
            <span className="text-[45px] font-bold">CMS crm</span>
            <br />
            <span className="text-[36px] whitespace-nowrap">Durian Technologies Inc.</span>
          </h1>
        </div>
      </div>

      <div className="flex flex-col justify-between items-center p-8 md:p-16 bg-white rounded-lg w-full md:w-[430px]">
        <form onSubmit={handleSubmit} className="flex flex-col justify-between items-center h-full w-full">
          <h1 className="text-4xl">Forgot Password</h1>

          <div>
            <p className="text-text-hint text-center mb-8">
              Enter your username or email address and we'll send you a verification code to reset your password.
            </p>

            <div className="flex flex-col gap-8">
              <div>
                <label htmlFor="email" className="text-text-hint">
                  Username / Email<span className="text-red-500">*</span>
                </label>
                <div className="flex items-center px-2 border border-neutral-500 rounded-lg">
                  <input
                    id="email"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    name="email"
                    type="text"
                    required
                    placeholder="Enter your username or email"
                    className="outline-none border-none focus:ring-0 flex-grow"
                  />
                  <img src={Pencil} alt="pencil" className="w-6 h-6" />
                </div>
              </div>
            </div>

            {error && (
              <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                <p className="text-red-600 text-sm">{error}</p>
              </div>
            )}

            {success && (
              <div className="mt-4 p-3 bg-green-50 border border-green-200 rounded-lg">
                <p className="text-green-600 text-sm">{success}</p>
              </div>
            )}
          </div>

          <div className="flex flex-col justify-between gap-2 items-center w-full">
            <button
              type="submit"
              disabled={isLoading}
              className="w-full py-2 px-4 text-base rounded-full text-white bg-secondary-600 hover:bg-secondary-700 disabled:bg-neutral-300 disabled:cursor-not-allowed"
            >
              {isLoading ? "Sending..." : "Send Verification Code"}
            </button>

            <p className="text-sm text-center ">
              Remember your password?{" "}
              <Link to="/login" className="text-info-500">
                Login
              </Link>
            </p>
            <p className="text-text-hint">or</p>
            <p>
              <Link to="/subscribe" className="text-info-500 font-bold">
                Subscribe
              </Link>{" "}
              for your Business
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
